import styled from 'styled-components';
import { Link } from '../../widgets/buttons';
import { AiPrimaryButton, AiSecondaryButton } from '../../widgets/aiComponents/aiComponents';

export const ServiceCreditsContainer = styled.div`
    background-color: #ffffff;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const ServiceCreditsSectionTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 4px;
    strong {
        color: ${(props) => props.theme.app.component.pageBlocksContainer.pageBlock.pageBlockTitle.color};
        font-size: ${(props) => props.theme.app.component.pageBlocksContainer.pageBlock.pageBlockTitle.fontSize};
        font-weight: ${(props) => props.theme.app.component.pageBlocksContainer.pageBlock.pageBlockTitle.fontWeight};
        font-family: 'Inter', sans-serif;
    }
    p {
        margin: 4px 0 0;
        padding: 0;
        font-size: ${(props) => props.theme.app.component.pageBlocksContainer.pageBlock.pageBlockDescription.fontSize};
        line-height: 16px;
        color: #546e7a;
    }
`;

export const ServiceCreditsTitleRow = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
`;

export const TrialBadgeWrapper = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
`;

export const ServiceCreditsContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
`;

export const CreditsInfoSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 0;
    gap: 4px;
    border-bottom: 1px solid #eef1f3;
`;

export const CreditsLabel = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 6px;

    strong {
        font-size: 24px;
        font-weight: 700;
        line-height: 1;
        color: #263238;
    }

    label {
        font-size: 12px;
        margin: 0;
        font-weight: 400;
        color: ${(props) => props.theme.app.textColor};
    }
`;

export const CreditsWarning = styled.div<{ $hidden?: boolean }>`
    color: #dc3545;
    font-size: 11px;
    visibility: ${(props) => (props.$hidden ? 'hidden' : 'visible')};
`;

export const SelectorsRow = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-start;
    width: 100%;

    > div {
        flex: 1;
        min-width: 0;
    }
`;

export const TierSelectionSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;

    label {
        font-size: 11px;
        font-weight: 400;
        color: #445a64;
        margin: 0;
    }
`;

export const ActionsSection = styled.div`
    margin-top: 16px;
    width: 100%;
    display: flex;
    gap: 10px;
    padding-top: 12px;
    border-top: 1px solid #eef1f3;
`;

export const PurchaseCreditsButton = styled(AiPrimaryButton)``;
export const ActivateTrialButton = styled(AiSecondaryButton)``;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
`;

export const AutoRefillSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 11px;
    color: #78909c;

    label {
        font-size: 11px;
        line-height: 16px;
        color: #546e7a;
    }

    p {
        font-size: 10px;
        color: #90a4ae;
        margin: 0;
        padding-left: 0;
    }
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    top: -70px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
`;

export const LinkSuccessPurchasingCreditsMessage = styled(Link)`
    color: #fff;
    font-weight: 700;
`;

export const PackageOptionLabel = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    font-size: 13px;

    > span:first-child {
        white-space: nowrap;
    }
`;

export const PackageOptionPrice = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    font-size: 13px;
`;

export const PackageOriginalPrice = styled.span`
    color: #9ca3af;
    text-decoration: line-through;
    font-size: 12px;
`;

export const PackageDiscountBadge = styled.span`
    color: #16a34a;
    font-weight: 700;
    font-size: 12px;
`;
